<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Close" (click)="closeEditLockCodeDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
            <span *ngIf="!isLoadingUpdates">
                {{ "su-management.lock-code.edit-title" | translate }}
            </span>
            <span *ngIf="isLoadingUpdates" class="text-green">
                {{ "su-management.lock-code.success" | translate }}
            </span>
        </h4>

        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3" style="min-height: 210px;">

            <span *ngIf="!isSuccessfullyUpdated && !isLoadingUpdates" [class.zx-100-opp]="isLoadingUpdates"
                class="text-center pt-2 pt-lg-3" [class.zx-ltr]="!isRTL">
                {{ "su-management.lock-code.explain" | translate }}
            </span>

            <form *ngIf="!isSuccessfullyUpdated && !isLoadingUpdates" #myForm="ngForm"
                class="d-flex flex-column align-items-center gap-3 w-100" (ngSubmit)="onSubmit()">
                <div class="form-group w-100" style="max-width: 300px;">
                    <mat-form-field class="w-100" [ngClass]="isRTL ? 'zx-rtl' : 'zx-ltr'">
                        <mat-label>{{ "su-management.lock-code" | translate }}</mat-label>
                        <input matInput type="text" [(ngModel)]="newLockCode" name="lockCode" #lockCodeInput="ngModel"
                            [placeholder]="'su-management.lock-code.placeholder' | translate">
                    </mat-form-field>
                </div>

                <button type="submit" class="d-none"></button>
            </form>

            <span class="spacer"></span>

            <div *ngIf="!isSuccessfullyUpdated && !isLoadingUpdates" [class.zx-100-opp]="isLoadingUpdates"
                class="d-flex flex-column flex-lg-row flex-grow-lg-1 justify-content-center align-items-end w-100 gap-3">
                <button color="primary" mat-raised-button
                    (click)="triggerFormSubmit()" class="text-white rounded-pill zx-btn-single col-12 col-lg-6 fw-bold">
                    {{ "su-management.save-changes" | translate }}
                </button>
                <button (click)="closeEditLockCodeDialog()" color="primary" mat-button
                    class="rounded-pill zx-btn-single col-12 col-lg-6 fw-bold">
                    {{ "su-management.branches_cancel" | translate }}
                </button>
            </div>

            <img *ngIf="isSuccessfullyUpdated && !isLoadingUpdates" src="assets/images/success-icon.svg"
                class="svg zx-success-icon position-absolute" alt="successfull update">

            <div *ngIf="isLoadingUpdates" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
        </div>

    </div>
</div>

